import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addRole } from 'api/role.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { RoleRequest } from 'types/entity';

export const ROLE_CREATE_STORE_NAME = 'roleCreate';

export const createRole = createAsyncThunk(
  `${ROLE_CREATE_STORE_NAME}/create`,
  async (payload: { projectId: string, role: RoleRequest }, thunkAPI) => {
    const { projectId, role } = payload;
    await addRole(projectId, role);
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.roleCreate.success' }));
  },
);

export interface RoleCreateState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialRoleCreateState: RoleCreateState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const roleCreateSlice = createSlice({
  name: ROLE_CREATE_STORE_NAME,
  initialState: initialRoleCreateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createRole.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(createRole.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(createRole.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const roleCreateActions = {
  ...roleCreateSlice.actions,
  createRole,
};

export default roleCreateSlice.reducer;
